import { onKeyDownToggleElement } from '@udecode/plate-common';

import { createMyPluginFactory } from '../plateFunctions';
import { ELEMENT_CALLOUT } from '../plateTypes';

const elevioClassMap: Record<string, string> = {
  'elevio-box-info': 'info',
  'elevio-box-warning': 'warning',
  'elevio-box-error': 'error',
  'elevio-box-success': 'success',
};
const varieties = Object.values(elevioClassMap);

/** Enables support for callout, which is a way of highlighting a piece of text. */
export const createCalloutPlugin = createMyPluginFactory({
  key: ELEMENT_CALLOUT,
  isElement: true,
  deserializeHtml: {
    rules: [
      {
        validNodeName: ['CITE', 'Q'],
        validClassName: 'callout',
      },
      {
        validNodeName: ['BLOCKQUOTE', 'DIV', 'P'],
        validClassName: 'callout',
      },
      {
        validNodeName: ['BLOCKQUOTE'],
        validClassName: 'elevio-box-info',
      },
      {
        validNodeName: ['BLOCKQUOTE'],
        validClassName: 'elevio-box-warning',
      },
      {
        validNodeName: ['BLOCKQUOTE'],
        validClassName: 'elevio-box-success',
      },
      {
        validNodeName: ['BLOCKQUOTE'],
        validClassName: 'elevio-box-error',
      },
      {
        validNodeName: ['CALLOUT', 'FIGURE'],
      },
    ],
    getNode: (el) => {
      const elevioMatch = Object.keys(elevioClassMap).find((name) =>
        el.classList.contains(name),
      );
      if (elevioMatch) {
        return { type: ELEMENT_CALLOUT, variety: elevioClassMap[elevioMatch] };
      }

      const varietyMatch = varieties.find((name) =>
        el.classList.contains(name),
      );
      return {
        type: ELEMENT_CALLOUT,
        variety: varietyMatch ?? 'neutral',
      };
    },
  },
  handlers: {
    onKeyDown: onKeyDownToggleElement,
  },
  options: {
    hotkey: 'mod+shift+c',
  },
});
